const BgHover = () => <div className="absolute top-0 left-0 z-10 w-full h-full group-hover:bg-black/40 transition-all duration-500" />

export default BgHover;